import { decryptAES } from "../CryptoService";
import { SwalAlert } from "../swalService/SwalService";
import { ToastService } from "../toastService/ToastService";
import { ErrorCode, handlerCustomErrorMessage } from "./helper/index.jsx";
import { translate } from "../../utils/translator";

// Function to show error alert using SwalAlert safely without module load race condition
const showError = (...args) => {
    const swal = SwalAlert();
    return swal.error(...args);
};

export const transformSuccessResponse = async (response, meta, arg) => {
    let rData = response;
    let apiData = rData;

    // Check if the response is encrypted.
    if (response.isEnType) {
        rData = decryptAES(rData); // Decrypt the data.
        apiData = rData
    }

    // Handle the Downalod File's
    if (arg?.isRawResponse) {
        return apiData;
    } else if (response.code === 200 || response.code === 201) {
        return apiData;
    }
    else {
        // Show a toast or alert with the API error message.
        showError(apiData.message ? apiData.message : "Something went wrong with the API");
        return null;
    }
}

export const transformErrorResponse = (response, meta, arg) => {
    let errorMessage = "Something went wrong";
    const status = response.status || response.code;

    // 1. Handle Fetch/Network Error
    if (status === "FETCH_ERROR") {
        if (arg?.skipErrorToast) {
            return { message: errorMessage, code: "FETCH_ERROR" };
        }
        errorMessage = "Network error. Please check your connection.";
        ToastService.error({ description: errorMessage });
        return { message: errorMessage, code: "FETCH_ERROR" };
    }

    // 2. Handle Parsing Error 
    if (status === "PARSING_ERROR") {
        if (arg?.skipErrorToast) {
            return { message: errorMessage, code: "PARSING_ERROR" };
        }
        errorMessage = "Unable to process server response.";
        showError(errorMessage);
        return { message: errorMessage, code: "PARSING_ERROR" };
    }

    // 3. Handle Standard API Errors
    let rData = response.data || response;

    // Decrypt if necessary
    if (rData?.isEnType) {
        rData = decryptAES(rData);
    }

    // Extract message
    errorMessage = rData?.message || rData?.data || ErrorCode[status] || "An unexpected error occurred";

    // Show appropriate alert based on status
    if (status === 401) {
        if (arg?.skipErrorToast) {
            return { message: errorMessage, code: status, data: rData };
        }
        // Handle Unauthorized (e.g., redirect to login if needed)
        ToastService.error({ description: "Session expired. Please login again." });
    } else if (status === 400 || status === 403) {
        if (arg?.skipErrorToast) {
            return { message: errorMessage, code: status, data: rData };
        }
        handlerCustomErrorMessage(errorMessage, arg?.swalAlertFire, showError);

    } else if (status === 500) {
        if (arg?.skipErrorToast) {
            return { message: errorMessage, code: status, data: rData };
        }
        // Server errors
        showError("Server error. Please contact administrative support.");
    } else if (meta.response.url.includes("/student/login")) {
        const now = new Date();
        const unlockTime = new Date(now.getTime() + 2 * 60 * 1000); // +2 min
        localStorage.setItem(
            "loginError",
            JSON.stringify({
                message: errorMessage,
                code: status,
                lockTime: now.toISOString(),
                unlockTime: unlockTime.toISOString(),
                tooManyAttempts: true
            })
        );
        showError(translate(`apiErrorResponse.${errorMessage}`),
            translate("apiErrorResponse.YOU_HAVE_EXCEEDED_ATTEMPTS_LIMIT_TITLE"));
    }
    else {
        if (arg?.skipErrorToast) {
            return { message: errorMessage, code: status, data: rData };
        }
        // Generic errors
        showError(translate(`apiErrorResponse.${errorMessage}`));
    }
    return {
        message: errorMessage,
        code: status,
        data: rData
    };
};
